import { MirageConstants } from "@shared/mirage/mirageConstants";

export class MirageRoutingService {
    public Root = `/${MirageConstants.CommonRoot}`;
    public Login = "login";
    public ForgotPassword = "forgotPassword";
    public ResetPassword = "resetPassword";

    public LoginRoute() {
        return this.toRoute(this.Root, this.Login);
    }
    public ForgotPasswordRoute() {
        return this.toRoute(this.Root, this.ForgotPassword);
    }
    public ResetPasswordRoute() {
        return this.toRoute(this.Root, this.ResetPassword);
    }
    toRoute(...parts: string[]) {
        return parts.join("/");
    }
}
